import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import MarkdownPage from "./components/MarkdownPage";
import { termsContent } from "./markdown/terms";
import { privacyContent } from "./markdown/privacy";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/privacy",
    element: <MarkdownPage content={privacyContent} title="Privacy Policy" />,
  },
  {
    path: "/terms",
    element: <MarkdownPage content={termsContent} title="Terms of Service" />,
  },
]);
